import React from 'react';
import PropTypes from 'prop-types';
import Row from './Row';
import Header from './Header';
import '../../shared/TimecardsTable.css';

const TimecardsTable = ({
  byEmployee,
  onRowSelect,
  ...props
}) => {
  return (
    <table className='timecards-table'>
      <Header />
      <tbody>
        { Object.keys(byEmployee).map(key => {
          const value = byEmployee[key];
          const { name, timecards, employeeId } = value;

          return (
            <Row
              key={`timecards-employee-${employeeId}`}
              employeeId={employeeId}
              name={name}
              timecards={timecards}
              onRowSelect={onRowSelect}
            />
          );
        })}
      </tbody>
    </table>
  );
};

TimecardsTable.propTypes = {
  byEmployee: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      name: PropTypes.string,
      timecards: PropTypes.arrayOf(PropTypes.object)
    })
  }),
  onRowSelect: PropTypes.func
};

export default TimecardsTable;
